
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/GridLegacy"
import TextField from "@mui/material/TextField"

import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../Redux/Tracking/actions";
import dynamic from "next/dynamic";
const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));



const Tracking = ({ trackingData }) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const { trackingRef, trackingCode, redirect, carriage_id } = useSelector((state) => state.trackingReducer);
    const { template_settings } = useSelector((state) => state.globalReducer);

    const {
        template_page_settings,
    } = trackingData;

    const [trackingDetails, setTrackingDetails] = useState({
        tracking: '',
        code: ''
    });

    useEffect(() => {
        if (carriage_id) {
            dispatch({ type: actions.TRACKING_RESET })
        }
    }, [])

    useEffect(() => {
        redirect && router.push({
            pathname: '/tracking/' + trackingDetails.tracking,
            query: trackingDetails.code && 'passcode=' + trackingDetails.code
        })
    }, [redirect])



    const handleChange = (e) => {
        setTrackingDetails(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const formSubmit = (e) => {
        e.preventDefault();
        if (trackingDetails.tracking == '') {
            dispatch({
                type: actions.TRACKING_INVALID, payload: {
                    status: false,
                    trackingRef: 'This field is required.'
                }
            })
        } else if (trackingDetails.code == '') {
            dispatch({
                type: actions.TRACKING_INVALID, payload: {
                    status: false,
                    trackingCode: 'This field is required.'
                }
            })
        }
        else {
            dispatch({ type: actions.TRACKING_GET, payload: trackingDetails.tracking })
        }
    }

    const renderTrackingHeading = () => {
        return (
            <>
                <Typography component="h1" variant="h3">Track your order</Typography>
                <Typography className="mt-3">Type tracking ref. to track your delivery or collection</Typography>
            </>
        )
    }

    const renderTrackingForm = () => {
        return (
            <form className="mt-2" onSubmit={formSubmit}>
                <Grid container spacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={8}>
                        <TextField
                            label="Tracking Ref."
                            name="tracking"
                            onChange={handleChange}
                            className="w-100"
                            helperText={trackingRef}
                            error={trackingRef != null ? true : false}
                        />
                    </Grid>

                    <Grid item xs={8}>
                        <TextField
                            label="Passcode"
                            name="code"
                            onChange={handleChange}
                            className="w-100"
                            helperText={trackingCode}
                            error={trackingCode != null ? true : false}
                        />
                    </Grid>
                    <Grid item xs={10}>
                        <Button type="submit" color="secondary" variant="contained">Track</Button>
                    </Grid>
                </Grid>
            </form>
        )
    }



    const toWrapComponents = [
        renderTrackingHeading(),
        renderTrackingForm(),
    ];


    return <>
        <BoxContainer className={"mt-2"}>
            {/* {addLayout(toWrapComponents, layout, layout_width)} */}
            {renderTrackingHeading()}
            {renderTrackingForm()}
        </BoxContainer>
    </>;
}


export default Tracking